import { LegalPageMarkdown } from '../components/LegalPageMarkdown'

/**
 * Privacy Policy — rendered from /docs/PRIVACY-POLICY.md
 *
 * Single source of truth: docs/PRIVACY-POLICY.md
 * This component loads and renders the markdown at runtime.
 */
export function PrivacyPage() {
  return (
    <LegalPageMarkdown
      filename="PRIVACY-POLICY"
      title="Política de Privacidade"
      otherLink={{ href: '/termos', label: 'Termos de Serviço' }}
    />
  )
}
